import { ACKNOWLEDGEMENT_TYPE, useTranslation } from "hhn-commons";
import * as React from "react";
import { useEffect } from "react";
import { SWITCH_TAB_TYPE, SwitchTabs } from "../../common/SwitchTabs";
import AlertHeaderWithDivider from "./AlertHeaderWithDivider";
import AlertsPanelHeader from "./AlertsPanelHeader";
import { AlertPanelHeaderContainer } from "./AlertsPanelHeader.style";

type AcknowledgementAlertHeaderProps = {
  onSetAcknowledgeType: (type: ACKNOWLEDGEMENT_TYPE) => void;
  counter?: number;
};

const AcknowledgementAlertHeader = ({
  onSetAcknowledgeType,
  counter = 0,
}: AcknowledgementAlertHeaderProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });
  const [tabValue, setTabTabValue] = React.useState<ACKNOWLEDGEMENT_TYPE>(
    ACKNOWLEDGEMENT_TYPE.PENDING,
  );

  useEffect(() => {
    onSetAcknowledgeType(tabValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue]);

  return (
    <AlertHeaderWithDivider>
      <AlertPanelHeaderContainer>
        <AlertsPanelHeader
          alertLabel={tNs("alerts.acknowledge")}
          counter={counter}
        />
        <SwitchTabs
          type={SWITCH_TAB_TYPE.ALERT}
          onTabValueChange={setTabTabValue}
        />
      </AlertPanelHeaderContainer>
    </AlertHeaderWithDivider>
  );
};
export default AcknowledgementAlertHeader;
